import Router from 'vue-router'
import AppIndex from '../views/index.vue'

// 生产环境懒加载
const _import = require('./_import_' + process.env.NODE_ENV)

export default new Router({
  routes: [
    { path: '*', component: _import('developing'), hidden: true },
    {
      path: '/',
      name: 'home',
      component: AppIndex,
      redirect: { name: 'mainPage' },
      children: [{
        path: 'index',
        name: 'mainPage',
        component: _import('column-content/MainPage')
      }, {
        path: 'search',
        name: 'search',
        component: _import('column-content/Search')
      }, {
        path: 'column/:columnId/contact_us',
        name: 'contactUs',
        component: _import('column-content/ContactUs')
      }, {
        path: 'column/:columnId/apply_cooperation',
        name: 'applyCooperation',
        component: _import('column-content/ApplyCooperation')
      }, {
        path: 'column/:columnId/donation_log',
        name: 'donationLog',
        component: _import('column-content/DonationLog')
      }, {
        path: 'column/:columnId/:subColumnId?/integral/:contentId',
        name: 'integral',
        component: _import('column-content/Integral')
      }, {
        path: 'column/:columnId/:subColumnId?/newslist/:listContentId',
        name: 'newsList',
        component: _import('column-content/NewsList')
      }, {
        path: 'column/:columnId/:subColumnId?/newslist/:listContentId/news/:newsContentId',
        name: 'news',
        component: _import('column-content/News')
      }, {
        path: 'column/:columnId/:subColumnId?/personlist/:listContentId',
        name: 'personList',
        component: _import('column-content/PersonList')
      }, {
        path: 'column/:columnId/:subColumnId?/personlist/:listContentId/person/:personContentId',
        name: 'person',
        component: _import('column-content/Person')
      }, {
        path: 'column/:columnId/:subColumnId?/articlelist/:listContentId',
        name: 'articleList',
        component: _import('column-content/ArticleList')
      }, {
        path: 'column/:columnId/:subColumnId?/articlelist/:listContentId/article/:articleContentId',
        name: 'article',
        component: _import('column-content/Article')
      }]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js